module.exports = __webpack_public_path__ + "static/media/right_arrow.a6d5c143.svg";